import { Pipe } from '@angular/core';
import { isString } from '../helpers/helpers';
var LeftTrimPipe = (function () {
    function LeftTrimPipe() {
    }
    LeftTrimPipe.prototype.transform = function (text, chars) {
        if (chars === void 0) { chars = '\\s'; }
        return isString(text)
            ? text.replace(new RegExp("^[" + chars + "]+"), '')
            : text;
    };
    return LeftTrimPipe;
}());
export { LeftTrimPipe };
LeftTrimPipe.decorators = [
    { type: Pipe, args: [{ name: 'ltrim' },] },
];
/** @nocollapse */
LeftTrimPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=ltrim.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/ltrim.js
// module id = 260
// module chunks = 4